__webpack_require__.p = "/newsletter-sign-up-form-with-success-message/";